const globalValues = {
   redirect: 'redirect_url',
   tenant: {
      name: 'tenant_name',
   },
   candidate: {
      journeyRandom: 'submission_random',
      firstName: 'submission_first_name',
      lastName: 'submission_last_name',
      phone_number: 'candidate_phone_number',
      submissionId: 'submission_id',
      stepId: 'candidate_step_id',
      email: 'candidate_email',
      birthdate: 'candidate_birthdate',
      id: 'candidate_id',
      postal_code: 'candidate_postal_code',
   },
   consultant: {
      firstName: 'consultant_first_name',
      lastName: 'consultant_last_name',
   },
};

export default Object.freeze(globalValues);

